import { Component, HostListener } from '@angular/core';
import { LoaderService } from './shared/services/common/loader/loader.service';
import { LocationStrategy } from '@angular/common';
import { VERSION } from './shared/constants';
import { environment } from '../environments/environment';
import { LocalStoreService } from './shared/services/common/local-store/local-store.service';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent {
	title = 'AiNext';

	showLoader: boolean = false;

	/*On Page Refresh or BACK Button, show browser confirmation message to user*/
	//@HostListener("window:beforeunload", ["$event"]) unloadHandler(event: Event) {
	//	event.returnValue = false;
	//}

	constructor(
		public loaderService: LoaderService,
		private localStore: LocalStoreService,
		private location: LocationStrategy
	) {
		// console.log("Version: " + VERSION);

		this.location.onPopState(() => {
			this.localStore.backClicked = true;
			return false;
		});
	}

	ngOnInit(): void {
		var me = this;
		this.loaderService.isLoading.subscribe((val: boolean) => {
			setTimeout(() => me.showLoader = val);
		});
		// $(document).on('readystatechange', (() =>{
		// 	if (document.readyState !== "complete") {
		// 					$('body').css('visibility','hidden');
		// 					$('#loader').css('visibility', 'visible');
		// 		        } else {
		// 						$('body').css('visibility','visible');
		// 						$('#loader').css('display', 'none');
		// 						$('#lo').css('display', 'block');
				        
		// 				}
		// }));

		$(document).ready(function () {

			if (environment.production) {
				//for disable right click
				$(document).bind("contextmenu", function (e) {
					return false;
				});
			}
		});
	}

	onActivate(event) {
		window.scroll(0, 0);
	}
}
